import axios from './axios.service'

const method = 'interests'

class InterestService {
  async getAll(queryData) {
    try {
      const response = await axios.get(`/${method}`, {
        params: { ...queryData }
      })
      return response.data
    } catch (error) {
      return error
    }
  }

  async getInterestInformation(id) {
    try {
      const response = await axios({
        method: 'get',
        url: `/${method}/${id}`
      })
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async deleteInterest(rowClicked) {
    try {
      const response = await axios.delete(`/${method}/${rowClicked.id}`)
      return response
    } catch (error) {
      return error
    }
  }

  async storeInterest(data) {
    try {
      const response = await axios({
        method: 'post',
        url: `/${method}`,
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async updateInterest(id, data) {
    try {
      const response = await axios({
        method: 'put',
        url: `/${method}/${id}`,
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error
    }
  }
}

export default new InterestService()
